import React, { Component } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Divider,
  IconButton,
  FormControlLabel,
  Checkbox,
  DialogTitle,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { Close, PersonAdd, Link as LinkIcon } from '@mui/icons-material';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Events from '../service/Events';

import AdminAPI from '../service/AdminAPI';

class CreateUserPopup extends Component {
    constructor(props) {
      super(props);

      this.state = {
        toggleValue: "single",
        show: false,
        title: "",
        startDate: dayjs(new Date()),
        endDate: dayjs(new Date()),
        isInifiniteEntries: false
      }
    }

    handleClose = () => {
      this.setState({ isInifiniteEntries: false, toggleValue: "single" });
      this.props.onClose();
    }

    handleSubmit = (ev) => {
      AdminAPI.CreateUser({
        email: ev.target.email.value
      })
      .then((_res) => {
        window.location.reload();
      })
      .catch(console.error);

      ev.preventDefault();
    }

    handleSubmitForMultiple = (ev) => {
      AdminAPI.CreateInvite({
        isInfinite: this.state.isInifiniteEntries,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        amount: ev.target.amount ? parseInt(ev.target.amount.value) : 0
      })
      .then((_res) => {
        var _websitePort = process.env.REACT_APP_WEBSITE_PORT;
        var _baseUrl = process.env.REACT_APP_DOMAIN
          ? `${process.env.REACT_APP_DOMAIN}${(_websitePort ? `:${_websitePort}` : "")}`
          : window.location.origin;

        navigator.clipboard.writeText(`${_baseUrl}/register?${_res.token}`)
        .then(() => {
          Events.onResult.emit('success', "Der Link wurde kopiert");
        
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(() => window.location.reload());
      })
      .catch(console.error);

      ev.preventDefault();
    }

    handleChange = (ev, value) => {
      if (value !== null) {
        this.setState({ toggleValue: value })
      }
    }

    handleChangeStartDate = (newVal) => {
      if(newVal > this.state.endDate) {
          Events.onResult.emit("error", "Anfangsdatum ist größer als Enddatum!");
          return;
      }

      this.setState({ startDate: newVal });
    }

    handleChangeEndDate = (newVal) => {
        if(newVal < this.state.startDate) {
            Events.onResult.emit("error", "Enddatum ist kleiner als Anfangsdatum!");
            return;
        }

        this.setState({ endDate: newVal });
    }

    handleHasInfiniteEntriesChange = (ev) => {
      this.setState({ isInifiniteEntries: !this.state.isInifiniteEntries });
    }

    renderDateInput = (params) => {
      return (
          <TextField 
              {...params} 
              fullWidth
              sx={{
                  '& .MuiOutlinedInput-root': {
                      bgcolor: 'white',
                      borderRadius: '10px',
                      '&:hover fieldset': {
                          borderColor: '#2e7d32',
                      },
                      '&.Mui-focused fieldset': {
                          borderColor: '#2e7d32',
                      },
                  }
              }}
          />
      );
  }

    render() {
      return (
          <Dialog
            open={this.props.show}
            onHide={this.handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: { xs: '12px', sm: '20px' },
                overflow: 'hidden',
                margin: { xs: '16px', sm: '32px' },
                maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
              }
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={this.handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'white',
                zIndex: 1,
                '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
              }}
            >
              <Close />
            </IconButton>

            {/* Header with gradient */}
            <Box
              sx={{
                background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                pt: { xs: 3, sm: 4 },
                pb: { xs: 2.5, sm: 3 },
                px: { xs: 2, sm: 3 },
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 1.5, sm: 2 }
              }}
            >
              <PersonAdd sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
              <DialogTitle sx={{ p: 0, flex: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                  Nutzer hinzufügen
                </Typography>
              </DialogTitle>
            </Box>

            <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                <ToggleButtonGroup
                  color="primary"
                  value={this.state.toggleValue}
                  exclusive
                  onChange={this.handleChange}
                  size={window.innerWidth < 600 ? 'small' : 'medium'}
                  sx={{
                    '& .MuiToggleButton-root': {
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: { xs: '0.8rem', sm: '0.9rem' },
                      px: { xs: 1.5, sm: 2 }
                    }
                  }}
                >      
                  <ToggleButton value="single">Einzelner Nutzer</ToggleButton>
                  <ToggleButton value="multiple">Mehrere Nutzer</ToggleButton>
                </ToggleButtonGroup>
              </Box>

              {this.state.toggleValue === "single" ? (
                <Box component="form" onSubmit={this.handleSubmit} id="single-user-form">
                  <TextField
                    fullWidth
                    type="email"
                    name="email"
                    label="Email des Kunden"
                    placeholder="kunde@gmail.com..."
                    sx={{ mb: 3 }}
                  />
                </Box>
              ) : (
                <Box component="form" onSubmit={this.handleSubmitForMultiple} id="multiple-user-form">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDateTimePicker
                      label="Start Datum"
                      value={this.state.startDate}
                      onChange={this.handleChangeStartDate}
                      sx={{ width: '100%', mb: 2 }}
                      renderInput={this.renderDateInput}
                    />

                    <br />
                    <br />

                    <MobileDateTimePicker
                      label="End Datum"
                      value={this.state.endDate}
                      onChange={this.handleChangeEndDate}
                      sx={{ width: '100%', mb: 3 }}
                      renderInput={this.renderDateInput}
                    />
                  </LocalizationProvider>

                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isInfinite"
                        checked={this.state.isInifiniteEntries}
                        onChange={this.handleHasInfiniteEntriesChange}
                      />
                    }
                    label="Besitzt kein Nutzlimit (Unendliche Nutzung)"
                    sx={{ mb: 3 }}
                  />

                  {!this.state.isInifiniteEntries && (
                    <TextField
                      fullWidth
                      type="number"
                      name="amount"
                      label="Maximale Anzahl von Anmeldungen"
                      placeholder="10"
                      inputProps={{ min: 1 }}
                    />
                  )}
                </Box>
              )}
            </DialogContent>

            <Divider />

            <DialogActions sx={{ 
              p: { xs: 2, sm: 3 }, 
              gap: { xs: 1.5, sm: 2 },
              flexDirection: { xs: 'column', sm: 'row' }
            }}>
              <Button
                onClick={this.handleClose}
                variant="outlined"
                size="large"
                fullWidth
                sx={{
                  borderRadius: '10px',
                  textTransform: 'none',
                  fontWeight: 600,
                  borderColor: '#ddd',
                  color: '#666',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  py: { xs: 1.2, sm: 1.5 },
                  order: { xs: 2, sm: 1 },
                  '&:hover': {
                    borderColor: '#bbb',
                    bgcolor: '#f5f5f5'
                  }
                }}
              >
                Schließen
              </Button>
              <Button
                type="submit"
                form={this.state.toggleValue === "single" ? "single-user-form" : "multiple-user-form"}
                variant="contained"
                size="large"
                fullWidth
                startIcon={this.state.toggleValue === "single" ? <PersonAdd /> : <LinkIcon />}
                sx={{
                  bgcolor: '#2e7d32',
                  color: 'white',
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  py: { xs: 1.2, sm: 1.5 },
                  borderRadius: '10px',
                  boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                  order: { xs: 1, sm: 2 },
                  '&:hover': {
                    bgcolor: '#1b5e20',
                    boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.2s ease'
                }}
              >
                Hinzufügen
              </Button>
            </DialogActions>
          </Dialog>
      );
    }
}

export default CreateUserPopup;
